import React, {useEffect, useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import {useAuth} from "../../contexts/authContext";
import {useHistory} from "react-router-dom";
import {getNewMessages} from "../../services/notifications";
import Collapse from "react-bootstrap/Collapse";
import {useTranslation} from "react-i18next";

// Icons
import backButtonImageLight from "../../assets/images/back_icon_light.svg";
import menuMessage from "../../assets/images/menu_message.svg";
import leagueListChevron from "../../assets/images/chevron_right.svg";
import menuInfo from "../../assets/images/menu_info.svg";
import padelboxIcon from "../../assets/images/padelbox_logo_horizontal_dark.svg";

// CSS Files
import "./SideMenu.css";

const SideMenu = (props) => {
   const [showMenu, setShowMenu] = useState(false);
   const [open, setOpen] = useState(false);
   const [newMessages, setNewMessages] = useState(0);
   const [currentLocation, setCurrentLocation] = useState("");
   const auth = useAuth();
   const history = useHistory();
   const { t } = useTranslation();

   window.setShowMenu = setShowMenu;

   const removeActiveEnrollment = enrollments => {
      return enrollments.filter(enrollment => enrollment.id !== auth.user.active_enrollment.id);
   };

   useEffect(() => {
      (async () => {
         let newMessages = await getNewMessages();
         setNewMessages(newMessages.count);
         setCurrentLocation(history.location.pathname);
      })();
   }, [history.location.pathname]);

   return (
      <>
         <CSSTransition
            in={showMenu}
            classNames={"menu-bg-animation"}
            timeout={1}>
            <div className={"menu-bg"} onClick={() => {
               setShowMenu(false);
            }}>
            </div>
         </CSSTransition>
         <CSSTransition
            in={showMenu}
            classNames={"menu-animation"}
            timeout={1}>
            <div className={"side-menu"}>
               <div className={"back-btn-container"}>
                  <img className="menu-back-btn"
                       src={backButtonImageLight}
                       alt="back button"
                       onClick={() => {
                          setShowMenu(false);
                       }}/>
               </div>
               <div className={'logo-container'}>
                  <img className={"padelbox-logo"} src={padelboxIcon} alt="logo padelbox"/>
               </div>
               <div className="menu-profile">
                  <div
                     className="menu-profile-header"
                     onClick={() => {
                        setCurrentLocation("");
                        history.push('/edit-account');
                        setShowMenu(false);
                     }}>
                     <div className={"profile-photo"} style={{backgroundImage: "url(" + auth.user.photo_url + ")"}}/>
                     <div>
                        <strong>{auth.user.name}</strong>
                        <span style={{color: "#949494"}}>{t('side_menu.edit_user')}</span>
                     </div>
                  </div>
                  <div className={"d-flex align-items-center position-relative"}>
                     {newMessages > 0 &&
                        <p className={"mr-2 new-messages"}>{newMessages}</p>
                     }
                     <img
                        style={{width: 36, height: 31, cursor: "pointer"}}
                        src={menuMessage}
                        alt="menu message button"
                        onClick={() => {
                           setCurrentLocation("");
                           history.push('/notifications');
                           setShowMenu(false);
                        }}
                     />
                  </div>
               </div>
               <div className="menu-actions">
                  {auth.user.enrollments?.length !== 0 &&
                     <div className={"league-list-container" + (open ? " open" : "")}>
                        <div className="active-league-block">
                           <img src={leagueListChevron} className="league-list-chevron" alt="league list chevron" onClick={() => setOpen(!open)}/>
                           <div className={"d-flex flex-column"}>
                              <span style={{fontSize: 14, color: "#FFF"}}>{auth.user.active_enrollment?.league}</span>
                              <span style={{fontSize: 13, color: "#AFFF55"}}>{auth.user.active_enrollment?.category}</span>
                           </div>
                        </div>
                        <Collapse in={open}>
                           <div className="league-list">
                              {removeActiveEnrollment(auth.user.enrollments).map((enrollment, key) => {
                                 return <div key={key} className={"league-block-container"} onClick={() => {
                                    auth.changeEnrollment(auth.user, enrollment)
                                    setOpen(!open);
                                 }}>
                                    <div className="league-block">
                                       <span style={{fontSize: 12, color: "#FFF"}}>{enrollment.league}</span>
                                       <span style={{fontSize: 12, color: "#AFFF55"}}>{enrollment.category}</span>
                                    </div>
                                    <hr/>
                                 </div>
                              })}
                           </div>
                        </Collapse>
                     </div>
                  }

                  <div className={"other-actions" + (auth.user.enrollments?.length !== 0 ? "" : " pt-2")}>
                      <span
                         className={currentLocation.includes("/schedule") ? "font-weight-bold" : ""}
                         onClick={() => {
                            history.push("/schedule");
                            setCurrentLocation("/schedule");
                            setShowMenu(false);
                         }}>
                           {t('side_menu.schedule')}
                     </span>

                     <span
                        className={currentLocation.includes("/my-games") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/my-games");
                           setCurrentLocation("/my-games");
                           setShowMenu(false);
                        }}>
                           {t('side_menu.my_matches')}
                     </span>

                     <span
                        className={currentLocation.includes("/ranking") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/ranking");
                           setCurrentLocation("/ranking");
                           setShowMenu(false);
                        }}>
                           {t('side_menu.ranking')}
                     </span>


                     <span
                        className={currentLocation.includes("/other-games") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/other-games");
                           setCurrentLocation("/other-games");
                           setShowMenu(false);
                        }}>
                        {t('side_menu.other_matches')}
                     </span>

                     <span
                        className={currentLocation.includes("/enrollment") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/enrollment/list");
                           setCurrentLocation("/enrollment");
                           setShowMenu(false);
                        }}>
                           {t('side_menu.registrations')}
                     </span>

                     <span
                        className={currentLocation.includes("/availabilities") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/availabilities");
                           setCurrentLocation("/availabilities");
                           setShowMenu(false);
                        }}>
                           {t('side_menu.availabilities')}
                     </span>

                     <span
                        className={currentLocation.includes("/substitutions") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/substitutions");
                           setCurrentLocation("/substitutions");
                           setShowMenu(false);
                        }}>
                           {t('side_menu.substitutions')}
                     </span>

                     <span
                        className={currentLocation.includes("/other-leagues") ? "font-weight-bold" : ""}
                        onClick={() => {
                           history.push("/other-leagues");
                           setCurrentLocation("/other-leagues");
                           setShowMenu(false);
                        }}>
                        {t('side_menu.other_leagues')}
                     </span>
                  </div>

                  <div className={"logout-container"}>
                      <span className="action-logout">
                         <span className={"p-0 logout"} onClick={() => auth.logout()}>{t('side_menu.logout')}</span>
                         <img className="logout-info" src={menuInfo} onClick={() => {
                            history.push("/about-us");
                            setCurrentLocation("");
                            setShowMenu(false);
                         }}/>
                     </span>
                  </div>
               </div>
            </div>
         </CSSTransition>
      </>
   )
}

export default SideMenu;
